import React from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/Magazine.css'
import she from './../assest/images/projectss/magazine/she.pdf'
import zen from './../assest/images/projectss/magazine/zen.pdf'
import sheg from './../assest/images/projectss/magazine/sheg.jpg'
import zenzen from './../assest/images/projectss/magazine/zenzen.png'
export const Magazine = () => {
  return (
    <div className='magazine'>
<Container>
    <div className='row'>
       <div className='col-lg-6 col-sm-12 col-md-12'>
        <img src={sheg}/>
        <h3>SHE Magazine</h3>
        <p>She Magazine is a vibrant publication that celebrates the essence of modern womanhood.</p>
        <button> <a href={she} download="she"> <i class="fa-solid fa-download"  style={{color: "#fff" ,fontSize:"30px", padding: "15px 15px",marginRight:"20px"}}></i> </a></button>
        </div> 
       <div className='col-lg-6 col-sm-12 col-md-12'>
        <img src={zenzen}/>
        <h3>ZEN Magazine</h3>
        <p>Zen Diamond was founded in 2000 with a deep-rooted family heritage and expertise
           in jewellery making, which have been passed down three generations since 1890.
           Core business of Zen Diamond is designing, producing and selling a broad range of diamond jewellery globally.</p>
       <button> <a href={zen} download="zen">  <i class="fa-solid fa-download"  style={{color: "#fff" ,fontSize:"30px", padding: "15px 15px",marginRight:"20px"}}></i></a></button></div> 
    </div>
</Container>
    </div>
  )
}
